import * as CRM from './CRM';
import * as inventory from './inventory';
import * as shop from './shop';

/**
 * LeafLink Parsers.
 * @type {Object<tbd>}
 */
export default {
  CRM,
  inventory,
  shop,
};
